@if (hintInfo()) {
  <ui-icon
    [matTooltip]="hintInfo()!"
    class="text-gray-400"
    [ngClass]="position() === 'right' ? 'order-2' : 'order-1'"
    icon="griddy-info-circle"
    [size]="16"></ui-icon>
}

@if (hintText()) {
  <span class="text-sm font-normal text-text-tertiary">{{ hintText() }}</span>
} @else if (hintButton()) {
  <span
    class="text-sm font-medium text-text-secondary hover:text-text-secondary-hover underline cursor-pointer"
    (click)="hintButton()!.callback()"
    >{{ hintButton()!.text }}</span
  >
} @else if (hintTextAndLink()) {
  <div class="flex items-center">
    <span class="text-sm font-normal text-text-primary">{{ hintTextAndLink()!.text }}</span>
    &nbsp;
    <a
      class="text-sm font-medium text-success-500 hover:text-success-600 cursor-pointer"
      [href]="hintTextAndLink()!.href"
      [target]="hintTextAndLink()!.keepCurrentTab ? '_self' : '_blank'"
      >{{ hintTextAndLink()!.link }}</a
    >
  </div>
}
